import clsx from 'clsx';

import type { FCCCN } from '../../types';

export const SummaryGroup: FCCCN = ({ children, className }) => {
    return <div className={clsx('grid xs:grid-cols-1 sm:grid-cols-2 sm:gap-x-32', className)}>{children}</div>;
};